<template>
  <div id="groupSideMenuMobile" :class="{ 'side-open': isShow }">
    <div class="side-close">
      <i @click="toggleSideMenu()"></i>
    </div>
    <a class="side-menu" @click="moveToHome()"> 개인 고객 </a>
    <a class="side-menu" @click="moveToOffice('groupSectionPrograms')">
      기업 고객
    </a>
    <p class="side-button" @click="moveToOffice('introduction')">제안서 받기</p>
  </div>
</template>
<script>
export default {
  name: 'SideMenuMobile',
  props:{
    isShow: {type: Boolean, default: false}
  },
  methods: {
    moveToHome() {
      location.href = '/f/'
    },
    moveToOffice(hash) {
      location.href = `/f/office/#${hash}`
    },
    toggleSideMenu() {
      this.$emit('toggle-show')
    },
  },
}
</script>
<style scope lang="scss">
#groupSideMenuMobile {
  display: none;
}
@media all and (max-width: 1023px) {
  $medium: 500;
  @mixin flexBox($fd: row, $jc: flex-start, $ai: flex-start) {
    display: flex;
    flex-direction: $fd;
    justify-content: $jc;
    align-items: $ai;
  }

  @mixin defaultIcon($url, $size: cover) {
    background-image: url($url);
    background-repeat: no-repeat;
    background-size: $size;
    background-position: center;
  }

  @mixin hiddenBreakLine($clamp: 1) {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: $clamp;
    -webkit-box-orient: vertical;
  }
  #groupSideMenuMobile {
    display: block;
    width: 300px;
    height: calc(var(--vh, 1vh) * 100);
    @include flexBox(column, flex-start, center);
    position: fixed;
    top: 0;
    right: 0;
    background-color: #000000;
    z-index: 12;
    transform: translateX(300px);
    transition: transform 0.3s ease;
    will-change: auto;
    &.side-open {
      transform: translateX(0);
    }
  }
  .side-close {
    width: 100%;
    padding: 15px 24px 12px;
    @include flexBox(row, flex-end, center);
    i {
      display: block;
      width: 24px;
      height: 24px;
      @include defaultIcon(
          'https://dcse8twossp9.cloudfront.net/static/img/v2/icon/close-white.svg'
      );
      cursor: pointer;
    }
  }
  .side-menu {
    width: 100%;
    padding: 14px 0;
    text-align: center;
    font-size: 16px;
    color: #ffffff;
    cursor: pointer;
    text-decoration: none;
    & + .side-menu {
      margin-top: 5px;
    }
    .login-btn{
      color: #ffffff;
      background: url(https://dcse8twossp9.cloudfront.net/static/img/v2/group/230919/login-white.svg) left center no-repeat;
      padding-left: 24px
    }
  }
  .side-button {
    width: auto;
    padding: 0 20px;
    height: 42px;
    border-radius: 14px;
    @include flexBox(row, center, center);
    background-image: linear-gradient(105deg, #6400c8, #ff7d00);
    cursor: pointer;
    color: #ffffff;
    font-size: 16px;
    font-weight: $medium;
    margin-top: 8px;
  }
  .side-bottom {
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    font-weight: $medium;
    color: #555555;
    text-align: center;
  }
  .side-separator{
    width: 50px;
    height: 1px;
    margin: 30px;
    background-color: #fff;
  }
}
</style>
